import { render, staticRenderFns } from "./VSort.vue?vue&type=template&id=11c8d1e6&"
import script from "./VSort.vue?vue&type=script&lang=js&"
export * from "./VSort.vue?vue&type=script&lang=js&"
import style0 from "./VSort.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports